var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    width: 42,
    height: 42,
    rx: 10,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1875,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7842 29.8243H13.0985V17.9554H16.7842V29.8243ZM14.9394 16.3351C14.5158 16.3366 14.1012 16.2126 13.7481 15.9786C13.395 15.7447 13.1192 15.4113 12.9555 15.0206C12.7918 14.6299 12.7476 14.1995 12.8285 13.7837C12.9093 13.3679 13.1117 12.9854 13.4098 12.6845C13.708 12.3837 14.0887 12.178 14.5038 12.0934C14.9188 12.0089 15.3497 12.0492 15.7418 12.2094C16.1339 12.3697 16.4697 12.6425 16.7068 12.9935C16.9439 13.3446 17.0716 13.758 17.0738 14.1816C17.0743 14.7496 16.8502 15.2948 16.4503 15.6984C16.0505 16.1019 15.5074 16.3303 14.9394 16.3351ZM30.5789 29.8243H26.9011V24.0469C26.9011 22.6702 26.8733 20.9039 24.9848 20.9039C23.0686 20.9039 22.775 22.3997 22.775 23.9477V29.8251H19.0932V17.9554H22.6282V19.5741H22.6798C23.0333 18.9691 23.5444 18.4713 24.1585 18.1338C24.7727 17.7964 25.4669 17.6319 26.1671 17.6578C29.8965 17.6578 30.5828 20.1176 30.5828 23.305V29.8251L30.5789 29.8243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/linked_icon.9e38b407aadd44ac7cee802dbeec8e5f.svg";
export { ForwardRef as ReactComponent };